import { useQuery } from '@tanstack/react-query'

import { type AppTimezonePreference } from '@sparkai/utils'

import { apiClient } from '../apiClient'
import {
  getOperatorPerformanceQueryTimezonePart,
  getOperatorPerformanceRequestHeaders,
} from './operatorPerformanceTimezone'

type GetAllOperatorProgramsRequest = {
  operatorId?: string
  startDate: string
  endDate: string
  timezonePreference?: AppTimezonePreference
}

type GetAllOperatorProgramsResponse = {
  programId: string
  displayName: string
  iconType: string | null
  isActive: boolean
  color: string
}[]

export function useGetAllOperatorPrograms({
  operatorId,
  startDate,
  endDate,
  timezonePreference,
}: GetAllOperatorProgramsRequest) {
  const timezoneQueryKeyPart = getOperatorPerformanceQueryTimezonePart(timezonePreference)

  return useQuery({
    queryKey: [
      'get-all-ms-programs',
      operatorId,
      startDate,
      endDate,
      ...(timezoneQueryKeyPart ? [timezoneQueryKeyPart] : []),
    ],
    queryFn: async () => {
      const headers = getOperatorPerformanceRequestHeaders(timezonePreference)
      const { data } = await apiClient.get<GetAllOperatorProgramsResponse>(
        `/int/v3/operators/${operatorId}/programs`,
        { params: { startDate, endDate }, ...(headers ? { headers } : {}) }
      )
      return data
    },
    enabled: Boolean(operatorId),
    refetchOnWindowFocus: false,
  })
}
